export const homeHeroSlider = () => {
  const sectionHomeHero = document.getElementById("homeHeroSlider");
  if (sectionHomeHero) {
    const splide = new Splide(".splide-home-hero", {
      type: "fade",
      drag: true,
      rewind: true,
      perPage: 1,
      autoScroll: false,
      arrows: true,
      pagination: false,
    });
    splide.mount();
  }
};

export const HomeReviewSlider = () => {
  const sectionHomeReview = document.getElementById("homeReview");
  if (sectionHomeReview) {
    const splide = new Splide(".splide-home-review", {
      type: "fade",
      drag: false,
      rewind: true,
      perPage: 1,
      autoScroll: false,
      arrows: false,
      pagination: false,
      autoplay: true,
      interval: 6000,
    });
    splide.mount();
  }
};

export const HomeInspirationsSlider = () => {
  const sectionHomeInspirations = document.getElementById("inspirationPart");
  if (sectionHomeInspirations) {
    const splide = new Splide(".splide-home-inspirations", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: false,
      arrows: true,
      gap: "8px",
      pagination: false,
      fixedHeight: "100%",
      breakpoints: {
        1200: {
          perPage: 4,
          perMove: 1,
        },
        991: {
          perPage: 3,
          perMove: 1,
          arrows: false,
          pagination: true,
        },
        576: {
          perPage: 2,
          perMove: 1,
        },
      },
    });
    splide.mount();
  }
};

export const HomeBlogSlider = () => {
  const sectionBlogInspirations = document.getElementById("blogPart");
  if (sectionBlogInspirations) {
    const splide = new Splide(".splide-home-blog", {
      type: "slide",
      perPage: 3,
      perMove: 1,
      drag: true,
      rewind: false,
      arrows: true,
      gap: "8px",
      pagination: false,
      fixedHeight: "80%",
      breakpoints: {
        1200: {
          perPage: 3,
          perMove: 1,
        },
        991: {
          perPage: 2,
          perMove: 1,
          arrows: false,
          pagination: true,
        },
        576: {
          perPage: 1,
          perMove: 1,
        },
      },
    });
    splide.mount();
  }
};

export const SimpleCategories = (element = null) => {
  const splideElement =
    element || document.querySelector(".splide--simple-categories");

  if (!splideElement) return;
  const splide = new Splide(splideElement, {
    type: "slide",
    perPage: 4,
    perMove: 1,
    rewind: false,
    gap: "24px",
    arrows: true,
    pagination: false,
    breakpoints: {
      1200: {
        fixedWidth: "30%",
        gap: "24px",
        perPage: 3,
      },
      767: {
        fixedWidth: "45%",
        gap: "16px",
        perPage: 2,
      },
      475: {
        fixedWidth: "45%",
        perPage: 2,
      },
    },
  });
  const barWrapper = splide.root.querySelector(
    ".simple-categories__slider-progress"
  );
  const bar = splide.root.querySelector(".simple-categories__slider-bar");

  splide.on("mounted", function () {
    const totalSlides = splide.Components.Slides.getLength();
    const visibleSlides = splide.options.perPage;

    if (totalSlides <= visibleSlides) {
      if (barWrapper) {
        barWrapper.style.display = "none";
      }
    } else {
      splide.on("move", function () {
        const maxScrollIndex = totalSlides - visibleSlides;
        const progress = Math.min(splide.index / maxScrollIndex, 1);

        if (bar) {
          const parentWidth = barWrapper.offsetWidth;
          const calculatedWidth = progress * parentWidth;
          const minWidth = 115;

          bar.style.width = `${Math.max(calculatedWidth, minWidth)}px`;
        }
      });
    }
  });
  splide.mount();
};

export const ProductMiniatureGallerySlider = (element = null) => {
  if (element) {
    ProductMiniatureGallerySliderLazy(element);
  } else {
    window.addEventListener("mousemove", ProductMiniatureGallerySliderLazy, {
      once: true,
    });
    window.addEventListener("scroll", ProductMiniatureGallerySliderLazy, {
      once: true,
    });
    window.addEventListener("touchstart", ProductMiniatureGallerySliderLazy, {
      once: true,
    });
  }
};

export const ProductMiniatureGallerySliderLazy = (element = null) => {
  if (
    ["Event", "TouchEvent", "MouseEvent"].includes(element?.constructor?.name)
  ) {
    element = null;
  }

  if (element === null) {
    if (window.productMiniatureGallerySlidersLoaded) return;
    window.productMiniatureGallerySlidersLoaded = true;
  }

  const sliders = element
    ? [element]
    : document.querySelectorAll(".splide--product-thumbnail-slider");

  sliders.forEach((sliderElement) => {
    new Splide(sliderElement, {
      type: "slide",
      perPage: 1,
      perMove: 1,
      rewind: true,
      drag: false,
      arrows: true,
      pagination: false,
      lazyLoad: "nearby",
    }).mount();
  });
};

export const completeProductsSlider = () => {
  const completeYourProduct = document.getElementById("completeYourProduct");
  if (completeYourProduct) {
    const splide = new Splide(".splide--complete-products", {
      type: "slide",
      perPage: 2,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "16px",
      breakpoints: {
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const relatedProductsSlider = () => {
  const relatedProducts = document.getElementById("relatedProducts");
  if (relatedProducts) {
    const splide = new Splide(".splide--related-products", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    splide.mount();
  }
};

export const upSellProductsSlider = () => {
  const upSellProducts = document.getElementById("upsellSlider");
  if (upSellProducts) {
    const splide = new Splide(".splide--product-upsell", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: false,
      pagination: true,
      gap: "24px",
      breakpoints: {
        1440: {
          gap: "24px",
          perPage: 3,
        },
        1100: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    const prevArrow = document.querySelector(".forget-slider-arrow--prev");
    const nextArrow = document.querySelector(".forget-slider-arrow--next");

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }
    splide.mount();
  }
};

export const mobileProductGallery = () => {
  const productGallery = document.getElementById("productGallery");
  if (productGallery) {
    if (window.innerWidth < 768) {
      const splide = new Splide(".splide--mobile-product-gallery", {
        type: "slide",
        perPage: 4,
        perMove: 1,
        drag: false,
        rewind: true,
        arrows: false,
        pagination: true,
        gap: "24px",
        breakpoints: {
          1440: {
            gap: "24px",
            perPage: 3,
          },
          1100: {
            gap: "16px",
            perPage: 2,
          },
          576: {
            perPage: 1,
          },
        },
      });
      splide.mount();
    }
  }
};

export const HomeBestsellersSlider = () => {
  const sectionBestsellers = document.getElementById("bestsellers");
  if (sectionBestsellers) {
    const splide = new Splide(".splide-home-bestsellers", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: true,
      pagination: false,
    });
    splide.mount();
  }
};

export const AboutFeaturesSlider = () => {
  const sectionAboutFeatures = document.getElementById("aboutFeatures");
  if (sectionAboutFeatures) {
    const splide = new Splide(".splide-about-features", {
      type: "slide",
      grid: {
        rows: 2,
        cols: 3,
        gap: {
          row: "64px",
          col: "32px",
        },
      },
      drag: false,
      rewind: false,
      arrows: false,
      pagination: true,
      breakpoints: {
        991: {
          grid: {
            rows: 3,
            cols: 2,
          },
        },
        767: {
          grid: false,
          drag: true,
        },
      },
    });
    splide.mount(window.splide.Extensions);
  }
};

export const plantTreeHowItWorksSlider = () => {
  const sectionPlantTreeHowItWorks = document.getElementById(
    "plantTreeHowItWorks"
  );
  if (sectionPlantTreeHowItWorks) {
    const splide = new Splide(".splide-plant-tree-how-it-works", {
      type: "slide",
      grid: {
        rows: 2,
        cols: 1,
        gap: {
          row: "32px",
          col: "32px",
        },
      },
      drag: false,
      rewind: false,
      arrows: false,
      pagination: true,
      breakpoints: {
        991: {
          grid: {
            rows: 1,
            cols: 1,
            drag: true,
            rewind: true,
          },
        },
        767: {
          grid: {
            rows: 1,
            cols: 1,
          },
          drag: true,
          rewind: true,
        },
      },
    });
    splide.mount(window.splide.Extensions);
  }
};

export const AboutGallerySlider = () => {
  const sectionAboutGallery = document.getElementById("aboutGallery");
  if (sectionAboutGallery) {
    const splide = new Splide(".splide-about-gallery", {
      type: "slide",
      perPage: 1,
      perMove: 1,
      drag: true,
      rewind: true,
      arrows: true,
      pagination: false,
    });
    var bar = splide.root.querySelector(".splide-slider-progress-bar");
    splide.on("mounted move", function () {
      var end = splide.Components.Controller.getEnd() + 1;
      var rate = Math.min((splide.index + 1) / end, 1);
      var maxWidth = 115;
      bar.style.width = String(maxWidth * rate) + "px";
    });
    splide.mount();
  }
};

export const DontForgetToAddToCartSlider = () => {
  const sectionDontForgetToAddToCart = document.getElementById(
    "dont-forget-to-add-to-cart"
  );
  if (sectionDontForgetToAddToCart) {
    const splide = new Splide(".splide-home-dont-forget-to-add-to-cart", {
      type: "slide",
      perPage: 4,
      perMove: 1,
      rewind: false,
      gap: "24px",
      pagination: false,
      arrows: false,
      breakpoints: {
        1200: {
          gap: "24px",
          perPage: 3,
        },
        991: {
          gap: "16px",
          perPage: 2,
        },
        767: {
          gap: "16px",
          perPage: 2,
        },
        576: {
          perPage: 1,
        },
      },
    });
    const prevArrow = document.querySelector(".forget-slider-arrow--prev");
    const nextArrow = document.querySelector(".forget-slider-arrow--next");

    if (prevArrow && nextArrow) {
      prevArrow.addEventListener("click", () => splide.go("<"));
      nextArrow.addEventListener("click", () => splide.go(">"));
    }
    splide.mount();
  }
};

export const refreshSlider = (sliderSelector, initFunction) => {
  const sliders = document.querySelectorAll(`.${sliderSelector}`);

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    if (sliderElement.splide) {
      sliderElement.splide.destroy();
    }

    initFunction(sliderElement);
  });
};

export const destroyExistingSlider = (sliderSelector) => {
  const sliderElements = document.querySelectorAll(`.${sliderSelector}`);

  sliderElements.forEach((sliderElement) => {
    if (sliderElement.splide) {
      sliderElement.splide.destroy();
    }
  });

  return sliderElements.length > 0 ? sliderElements : null;
};

export const loadHomeSliders = () => {
  if (window.homeSlidersLoaded) return;
  window.homeSlidersLoaded = true;

  HomeReviewSlider();
  HomeBestsellersSlider();
  HomeInspirationsSlider();
  HomeBlogSlider();
};
